import React, { useState, useRef } from "react";

export default function AddGrowthDetails({eleRef}) {

    const errorTimer = useRef(null);
    const fieldErrorTimers = useRef({});
    const dateRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [openHeight, setOpenHeight] = useState(false);
    const options = ["cm", "in"];

    // const getTodayDate = () => {
    //     return new Date().toISOString().split("T")[0];
    // };
    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };

    const [error, setError] = useState("");
    const [formData, setFormData] = useState({
        date: getTodayDate(),
        weight: "",
        height: "",
        hc: "",
        hcUnit:"cm",
        heightUnit:"cm"
    });

    const [fieldErrors, setFieldErrors] = useState({
        weight: { msg: "", visible: false },
        height: { msg: "", visible: false },
        hc: { msg: "", visible: false }
    });

    const showError = (msg) => {
        setError(msg);

        if (errorTimer.current) {
            clearTimeout(errorTimer.current);
        }

        errorTimer.current = setTimeout(() => {
            setError("");
        }, 2000);
    };

     const formatDate = (dateStr) => {
        if (!dateStr) return "";

        const date = new Date(dateStr);

        return date.toLocaleDateString("en-GB", {
            day: "numeric",
            month: "long",
            year: "numeric"
        });
    };

    const handleSelect = (value) => {
        setFormData({
        ...formData,
        hcUnit: value
        });
        setOpen(false);
    };


    const handleChange = (e) => {
        const { name, value } = e.target;

        let errors = { ...fieldErrors };

        const numericFields = ["weight", "height", "hc"];

        // ✅ Apply validation only for numeric fields
        if (numericFields.includes(name) && /[^0-9.]/.test(value)) {

            if (name === "weight") errors.weight = { msg: "Weight between 1–100", visible: true };
            if (name === "height") errors.height = { msg: "Height between 1 to 1000", visible: true };
            if (name === "hc") errors.hc = { msg: "Head circumference between 1 to 1000", visible: true };

            setFieldErrors(errors);

            setTimeout(() => {
                setFieldErrors(prev => ({
                    ...prev,
                    [name]: { ...prev[name], visible: false }
                }));
            }, 2000);

            setTimeout(() => {
                setFieldErrors(prev => ({
                    ...prev,
                    [name]: { msg: "", visible: false }
                }));
            }, 2000);

            return;
        }

        // ✅ Range validation only for numeric fields
        if (numericFields.includes(name)) {

            if (value === "0") {
                const errorMessages = {
                    weight: "Weight cannot be 0",
                    height: "Height cannot be 0",
                    hc: "Head circumference cannot be 0"
                };

                errors[name] = {
                    msg: errorMessages[name],
                    visible: true
                };

                setFieldErrors(errors);

                setTimeout(() => {
                    setFieldErrors(prev => ({
                        ...prev,
                        [name]: {
                            msg: "",
                            visible: false
                        }
                    }));
                }, 2000);

                return;
            }


            const numericValue = parseFloat(value);

            if (name === "weight" && numericValue > 100) {
                errors.weight = { msg: "Weight between 1–100", visible: true };
                setFieldErrors(errors);

                setTimeout(() => {
                    setFieldErrors(prev => ({
                        ...prev,
                        [name]: { ...prev[name], visible: false }
                    }));
                }, 2000);
                return;
            }

            if (name === "height" && numericValue > 1000) {
                errors.height = { msg: "Height between 1 to 1000", visible: true };
                setFieldErrors(errors);
                setTimeout(() => {
                    setFieldErrors(prev => ({
                        ...prev,
                        [name]: { ...prev[name], visible: false }
                    }));
                }, 2000);
                return;
            }

            if (name === "hc" && numericValue > 1000) {
                errors.hc = { msg: "Head circumference between 1 to 1000", visible: true };
                setFieldErrors(errors);
                setTimeout(() => {
                    setFieldErrors(prev => ({
                        ...prev,
                        [name]: { ...prev[name], visible: false }
                    }));
                }, 2000);
                return;
            }
        }

        // ✅ Update formData for ALL fields (including select)
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        setFieldErrors(errors);
        setError("");
    };

    const handleSave = () => {
        if (!formData.date) {
            showError("Please select date");
            return;
        }

        if (formData.date > getTodayDate()) {
            showError("Future dates are not allowed");
            return;
        }

        if (!formData.weight && !formData.height && !formData.hc) {
            showError("Please enter valid Information.");
            return;
        }

        setError("");
        eleRef.addGrowthDetails(formData);
    };

    const handleCancel =()=>{
        eleRef.closeAddGrowthModal();
    }

    const capitalize = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1) : "";

    const toggleUnit = (valueKey, unitKey) => {
        const isCm = formData[unitKey] === "cm";
        const value = parseFloat(formData[valueKey]);

        setFormData(prev => ({
            ...prev,
            [unitKey]: isCm ? "in" : "cm",
            [valueKey]:
                prev[valueKey] === ""
                    ? ""
                    : Number(
                        (
                            isCm
                                ? value / 2.54
                                : value * 2.54
                        ).toFixed(1)
                    ),
        }));
    };

    return (
        <div className="addGrowthmodal-overlay">
            <div className="addGrowthmodal">
                <div className="closeAddGrthBtn" onClick={handleCancel} >
                    <img className="closeBtnImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/closeBtn.png"></img>
                </div>
                <div className="modal-title">
                    <span className="add_growth_title" >Add Growth Details</span>
                </div>

                <div className="growthInputBox_div">
                    <div className="growthInputBox">
                        {/* Date */}
                        <div className="growthInput">
                            <div className="inputlabel">
                                <span>Date</span>    
                            </div>
                            <div className="input-with-icon vaccineDate"  onClick={() => dateRef.current?.showPicker?.()}>
                                
                                <div className="datecontainer">
                                   
                                    <input
                                        ref={dateRef}
                                        type="date"
                                        name="date"
                                        value={formData.date}
                                        max={getTodayDate()}
                                        onChange={(e) => {
                                            const selectedDate = e.target.value;
                                            const today = getTodayDate();

                                            if (selectedDate > today) {
                                                showError("Future dates are not allowed");
                                                return;
                                            }

                                            setFormData(prev => ({
                                                ...prev,
                                                date: selectedDate
                                            }));

                                            setError("");
                                        }}
                                        style={{ position: "absolute", opacity: 0 }}
                                    />

                                    <span className="date_text">
                                        {formatDate(formData.date)}
                                    </span>
                                </div>
                                <span className="date_icon_vaccine">
                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_calender.svg" />
                                </span>

                            </div>

                        </div>

                        {/* Weight */}
                        <div className="growthInput">
                            <div className="inputlabel">
                                <span>Weight</span>
                            </div>
                            <div className="input-with-unit">
                                <input className="R16_21" autoComplete="off" name="weight" value={formData.weight} onChange={handleChange} id="weightSave" />
                                <span className="wtspan">Kg</span>
                            </div>

                            {fieldErrors.weight.msg && (
                                <div className={`field-error ${fieldErrors.weight.visible ? "show" : "hide"}`}>
                                    {fieldErrors.weight.msg}
                                </div>
                            )}
                        </div>


                        {/* Height */}
                        <div className="growthInput">
                            <div className="inputlabel">
                                <span>Height</span>
                            </div>
                            <div className="input-with-unit">
                                <div className="inputcontainer">
                                    <input className="R16_21" name="height" value={formData.height} onChange={handleChange} autoComplete="off" id="heightSave"/>
                                </div>
                                <div className="custom-select">
                                    <div className="selected" onClick={() => toggleUnit("height", "heightUnit")}>
                                        {capitalize(formData.heightUnit)}
                                        <span className={`arrow ${formData.heightUnit === "in" ? "rotate" : ""}`}>
                                            <img
                                                src="https://cdn.cdnparenting.com/articles/babynameimages/ic-dropdown.svg"
                                                alt=""
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>
                            {fieldErrors.height.msg && (
                                <div className={`field-error ${fieldErrors.height.visible ? "show" : "hide"}`}>
                                    {fieldErrors.height.msg}
                                </div>
                            )}
                        </div>

                       

                        <div className="growthInput">
                            <div className="inputlabel">
                            <span>Head Circ.</span>
                            </div>
                            <div className="input-with-unit">
                                <div className="inputcontainer">
                                    <input className="R16_21" autoComplete="off" name="hc" value={formData.hc} onChange={handleChange} id="headSave"/>
                                </div>

                                <div className="selected" onClick={() => toggleUnit("hc", "hcUnit")}>
                                    {capitalize(formData.hcUnit)}
                                    <span className={`arrow ${formData.hcUnit === "in" ? "rotate" : ""}`}>
                                        <img
                                            src="https://cdn.cdnparenting.com/articles/babynameimages/ic-dropdown.svg"
                                            alt=""
                                        />
                                    </span>
                                </div>
                            </div>
                            {fieldErrors.hc.msg && (
                                <div className={`field-error ${fieldErrors.hc.visible ? "show" : "hide"}`}>
                                    {fieldErrors.hc.msg}
                                </div>
                            )}
                        </div>
                        
                    </div>
                </div>
                {error && (
                    <div className="form-error">
                        {error}
                    </div>
                )}
                {/* Buttons */}
                <div className="modal-actions">
                    <div className="btn-cancel" onClick={handleCancel} >
                        Cancel
                    </div>
                    <div className="btn-save M16_white" onClick={handleSave}>
                        Save
                    </div>
                </div>
            </div>
        </div>
    )

}